/* -------------------------------------------------------

    UC 2014 Include
    updated April 2015 CM / JH

------------------------------------------------------- */

//add custom tags elements
var includes = '',

// project folder
//folder_name = 'events/uc',
folder_name = (location.hostname.indexOf('esri.com') != -1) ? 'events/uc/uc_esri' : 'events/uc',

tier = 'webapps-cdn.esri.com',
// CDN root
CDN_dir = '//webapps-cdn.esri.com/CDN/page-templates/'+folder_name+'/';
// CDN switch case for DEV testing

switch(location.hostname){

  case 'cmsdev.esri.com':
  case 'webapps-cdn-dev.esri.com':
    CDN_dir = "//webapps-cdn-dev.esri.com/CDN/page-templates/"+folder_name+"/";
    tier = 'webapps-cdn-dev.esri.com';
  break;

  case 'webapps-cdn-stg.esri.com':
  case 'cmsqa.esri.com':
    CDN_dir = "//webapps-cdn-stg.esri.com/CDN/page-templates/"+folder_name+"/";
    tier = 'webapps-cdn-stg.esri.com';
  break;

}

includes += '<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />'
+'<link href="//'+tier+'/CDN/page-templates/general/css/animation-library.css" rel="stylesheet" type="text/css" />'
+'<link rel="stylesheet" type="text/css" href="//'+tier+'/CDN/esri-core/css/esri-core.css">'
+'<script src="//'+tier+'/CDN/components/StickyElement/_events-include.js"></script>';

var
scripts_dir = CDN_dir+"js/",
scripts = [];

scripts.push(
  "uc.js"
);

var
styles_dir = CDN_dir+"css/",
styles =[];
styles.push(
  "scrolling-page.css",
  "uc.css",
  "uc-2014-subpage-nav.css"
);
var
script,style,sc,st,
sc_len = scripts.length,
st_len = styles.length;

//scripts
for(sc = 0; sc < sc_len; sc++){
  script = scripts[sc];
  includes+='<script type="text/javascript" src="'+scripts_dir+script+'"></script>';
}
//styles
for(st = 0; st < st_len; st++){
  style = styles[st];
  includes+='<link href="'+styles_dir+style+'" rel="stylesheet" type="text/css">';
}

//add custom tags elements
includes+="<script>if(jQuery){jQuery(document).ready(function(){"
+"jQuery('.page-section').eq(1).before(jQuery('#navigation'));"
+"jQuery('.sticky-element-placeholder').eq(0).remove();"
+"__sticky.GO();"
+"});}</script>"
+"<!--[if IE 7]><link rel='stylesheet' type='text/css' href='//"+tier+"/CDN/page-templates/events/uc/css/uc-2014-ie7.css' /><![endif]-->"
+"<!--[if IE 8]><link rel='stylesheet' type='text/css' href='//"+tier+"/CDN/page-templates/events/uc/css/uc-2014-ie8.css' /><![endif]-->"
+"<!--[if IE 9]><link rel='stylesheet' type='text/css' href='//"+tier+"/CDN/page-templates/events/uc/css/uc-2014-ie9.css' /><![endif]-->"
+"<!--[if lt IE 9]><script src='//html5shim.googlecode.com/svn/trunk/html5.js'></script><![endif]-->"
+"<style>#nav-scroll { display: none; }</style>"
;

document.write(includes);
/*
document.write("<script>jQuery(document).load(function(){"
+"jQuery('.page-section').eq(1).before(jQuery('#navigation'));"
+"jQuery('.sticky-element-placeholder').eq(0).remove();"
+"__sticky.GO();"
+"});</script>");
*/
